<div class="animated container-fluid">
    <form class="needs-validation" [formGroup]="form" novalidate>

        <h4 *ngIf="inspeccionPeriodo !== null && inspeccionPeriodo !== undefined">
            {{ title }} Inspección {{inspeccionPeriodo?.IdCampaniaDescripcion}} - {{inspeccionPeriodo?.DescripcionPeriodo}}
        </h4>
        
        <h4 *ngIf="(datosPeriodo !== null && datosPeriodo !== undefined) && (inspeccionPeriodo === null || inspeccionPeriodo === undefined)">
            {{ title }} Inspección {{datosPeriodo?.IdCampaniaDescripcion}} - {{datosPeriodo?.DescripcionPeriodo}}
        </h4>

        <div class="row">
            <div class="col-md-12">

                <div class="row">

                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedCabecera = !isCollapsedCabecera" [attr.aria-expanded]="!isCollapsedCabecera" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Datos Inspección
                                    <i *ngIf="isCollapsedCabecera" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedCabecera" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsedCabecera" [ngbCollapse]="isCollapsedCabecera">

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="IdTipoInspeccion">Tipo</label>
                                            <ng-select appendTo="body"
                                                       [items]="tiposInspeccion"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdTipoInspeccion"
                                                       loadingText="Cargando..."
                                                       [loading]="(!tiposInspeccion || tiposInspeccion.length === 0)"
                                                       placeholder="-- Seleccione un Tipo de Inspección  --"
                                                       notFoundText="Tipo de Inspección no encontrado"
                                                       clearAllText="Eliminar selección">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                                </ng-template>
                                            </ng-select>
                                        </div>
                                        <div class="form-group col-md-8">
                                            <label class="col-form-label" for="intDescripcion">Nombre</label>
                                            <input formControlName="Nombre" name="Nombre" class="form-control" maxlength="150" inputStyleClass="form-control" type="text" value="">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-12">
                                            <label class="col-form-label" for="intDescripcion">Definición</label>
                                            <input formControlName="Definicion" name="Definicion" class="form-control" maxlength="500" inputStyleClass="form-control" type="text" value="">
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpActiva">Tiene Fecha Fin</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="TieneFechaFin" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inpActiva">Obligatoria</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="Obligatoria" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                            offIcon="pi pi-times"></p-toggleButton>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </form>
</div>
